import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  container: { padding: 10 },
  contentContainer: {
    borderRadius: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 0, // Increased for better visibility
    },
    shadowOpacity: 0.25, // Reduced for subtlety
    shadowRadius: 3,
    elevation: 5, // Critical for Android
    backgroundColor: "white",
    justifyContent: "center",
    maxWidth: "47%",
    minWidth: "47%",
    paddingVertical: 10,
    padding: 10,
    marginBottom: 10, // Add spacing between items
  },
  emptyContainer: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
  emptyTitle: {
    fontFamily: typography.primary.normal,
    fontSize: 25,
    padding: 20,
    textAlign: "center",
  },
  flex: { flex: 1 },
  headerContainer: { borderBottomLeftRadius: 10, borderBottomRightRadius: 10 },
  headerLogoContainer: { flexDirection: "row", justifyContent: "space-around", width: 85 },
  modalContainer: {
    alignItems: "center",
    alignSelf: "center",
    backgroundColor: colors.white,
    borderRadius: 20,
    maxWidth: 800,
    padding: 20,
  },
  redeemButton: {
    marginHorizontal: 10,
  },
  modalDescriptionText: {
    fontFamily: typography.primary.normal,
    marginBottom: 10,
    textAlign: "center",
  },
  modalImage: {
    alignSelf: "center",
    height: 200,
    position: "absolute",
    top: -120,
    width: 200,
    zIndex: 99,
  },
  modalTextContainer: { alignItems: "center", marginTop: 60 },
  modalTitleText: {
    fontFamily: typography.primary.normal,
    fontSize: 18,
    marginBottom: 10,
    marginTop: 20,
    textAlign: "center",
  },
  mt10: { marginTop: 10 },
  pb20: { paddingBottom: 20 },
  pointContainer: {
    backgroundColor: colors.pivilegePointContainer,
    borderRadius: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
    padding: 10,
    paddingHorizontal: 10,
  },

  pointText: {
    fontFamily: typography.primary.normal,
    fontSize: 14,
    marginTop: 5,
  },
  redeemLaterButton: {
    backgroundColor: colors.white,
    borderWidth: 1,
    flex: 1,
    marginRight: 20,
  },
  redeemModalContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 20,
    width: "100%",
  },
  spaceBetween: { justifyContent: "space-between", padding: 4 },
  text: { color: colors.white, fontFamily: typography.primary.normal },
  voucherText: { flex: 1, fontFamily: typography.primary.normal, fontSize: 16, marginTop: 10 },
  tierContentContainer: { borderRadius: 10, marginTop: 10, padding: 20, paddingLeft: 0 },
  row: { alignItems: "center", flexDirection: "row" },
  tierSpendText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
  },
  whiteDash: {
    width: "100%",
    borderWidth: 1,
    borderColor: "white",
    borderStyle: "dashed",
  },
  leftCurved: {
    position: "absolute",
    width: 30,
    height: 30,
    borderRadius: 100,
    backgroundColor: `white`,
    top: 55,
    left: -15,
    zIndex: 1,
  },
  RightCurved: {
    position: "absolute",
    width: 30,
    height: 30,
    borderRadius: 100,
    backgroundColor: `white`,
    top: 55,
    right: -15,
    zIndex: 1,
  },
  flatListContainer: {
    padding: 10,
  },
})
